import { IEntity } from "./IEntity";


export interface IEntityState {
  _entityState: EntityState;
  _modifiedProperties: Set<string>;


  _originalValues?: Map<string, any>;       // utilisé dans les composants de détail
  _modifiedValues?: Map<string, any>;       // utilisé dans les composants de détail
  _undoState?: Map<string, boolean>;        // utilisé dans les composants de détail
}
export enum EntityState {
    Detached = 0,
    Unchanged = 1,
    Deleted = 2,
    Modified = 3,
    Added = 4
}

export interface IChangedEntity {
    entity: IEntity;
    state: EntityState;
}
